module.exports = __webpack_public_path__ + "static/img/about049.40e660a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about049.png
// module id = gllr
// module chunks = 1